<div class="card shadow-none border-0">
  <div class="card-body pt-2">
    <div class="row mt-2 mb-4">
      <div class="col-5">
        <span class="nav-font18 nav-secondary font-weight-bold">{{screeningCriteria ? 'Edit' : 'Add'}} Screening Criteria</span>
      </div>
      <div class="col d-flex align-items-center justify-content-end">
        <i class="fas fa-close cursor-pointer grey4" (click)="closeModal()"></i>
      </div>
    </div>

    <div class="ckeditor position-relative">
      <or-wysiwyg (messageEvent)="wysiwygUpdate($event)" [config]="editorConfig"  [data]="note.message"></or-wysiwyg>
    </div>

    <div class="d-flex align-items-center justify-content-end">
      <span type="button" class="btn btn-sm nav-btn-primary shadow-none font-weight-bold"
        (click)="cancel()">Cancel</span>
      <span type="button" class="btn ml-2 btn-sm nav-btn-accent shadow-none font-weight-bold"
        (click)="save()">Save</span>
    </div>


  </div>
</div>

